import * as React from 'react';
import RawTransactionView from 'src/RawTransactionListView';

/**
 * Transactions tab of the account detail page. Breadcrumbs and the account
 * header are owned by the AccountDetail layout route. Reconciliation lives
 * on its own tab (AccountReconcileView).
 */
export const AccountTransactionsView = () => (
  <RawTransactionView includeProcessed />
);
